const resources = {
    biFreeShip: 'Beauty Insiders enjoy *{color:red}FREE standard shipping* on all orders{color}.',
    freeShipQualifies: 'You now qualify for *{color:red}FREE standard shipping.{color}*'
};

module.exports = function getResource(label) {
    return resources[label];
};
